import {
  UPDATE_MATCHES_STARTED,
  UPDATE_MATCHES_ENDED,
} from '../constants';

const INITIAL_STATE = {
  isMatching: false,
};

export default function(state = INITIAL_STATE, action) {
  const { type, payload } = action;

  switch (type) {

  case UPDATE_MATCHES_STARTED: {
    return {...state, isMatching: true};
  }

  case UPDATE_MATCHES_ENDED: {
    return {...state, isMatching: false};
  }

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/matches.js